import * as React from 'react';
import { ComparisonNotification } from './components/ComparisonNotification';
import { ComparisonControl } from './components/ComparisonControl/ComparisonControl';
import { jsx as _jsx } from "react/jsx-runtime";
export const NOTIFICATION_EXPIRATION_DELAY = 15000;
export const CompareNotificationContainer = _ref => {
  let {
    notification,
    clearNotification
  } = _ref;
  const [timeoutId, setNotificationTimeout] = React.useState(null);
  React.useEffect(() => {
    setNotificationTimeout(setTimeout(() => {
      clearNotification();
    }, NOTIFICATION_EXPIRATION_DELAY));
    return () => {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  }, [notification]);
  const handleLinkClick = React.useCallback(() => {
    setNotificationTimeout(setTimeout(() => {
      clearNotification();
    }, NOTIFICATION_EXPIRATION_DELAY));
  }, [notification]);
  const handleClose = React.useCallback(() => {
    clearNotification();
  }, []);
  const handleMouseEnter = React.useCallback(() => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);
  if (!notification || !notification.text) {
    return null;
  }
  return /*#__PURE__*/_jsx(ComparisonNotification, {
    control: /*#__PURE__*/_jsx(ComparisonControl, {
      url: notification.url,
      handleLinkClick: handleLinkClick,
      handleClose: handleClose
    }),
    text: notification.text,
    onMouseEnter: handleMouseEnter
  });
};